import { orderServiceListQuery, orderServiceCountQuery } from "./orderService";

const model = "vendors";

export const useVendorList = orderServiceListQuery({ model });
export const useVendorCount = orderServiceCountQuery({ model });
